module.exports = __webpack_public_path__ + "img/calendar-outline-yellow.be282236.svg";